import { put, takeEvery } from 'redux-saga/effects'
import {
  DISPLAYAREAS_LOADING, DISPLAYAREAS_BY_ID_LOADING, DISPLAYAREAS_BY_ID_AND_TYPE_LOADING,
  GET_DISPLAYAREAS_DATA_SUCCESS, GET_DISPLAYAREAS_DATA_ERROR
} from "../actions/actionDisplayAreas";
import { apiDisplayAreas, apiDisplayAreasById, apiDisplayAreasByIdAndType } from 'api';

async function fetchAsync(func, param1, param2) {
  const response = await func(param1, param2);

  if (response.ok && response.status == 200) {
    return await response.json();
  }
  else if (response.status == 204) {
    throw new Error("No display areas record found.");
  }
  else if (response.status === 'Unauthorized') {
    throw new Error("Authorization has been denied for this request.");
  }
  else {
    throw new Error("Unable to Get Display Areas, response: " + response.statusText + " - " + response.status)
  }
}

function* fetchDisplayAreasData(action) {
  try {
    const data = yield fetchAsync(apiDisplayAreas, action.displayAreaType)
    yield put({ type: GET_DISPLAYAREAS_DATA_SUCCESS, payload: data, id: action.id, isDisplay: action.isDisplay });
  } catch (e) {
    yield put({ type: GET_DISPLAYAREAS_DATA_ERROR, error: e.message });
  }
}

function* fetchDisplayAreasByIdData(action) {
  try {
    const data = yield fetchAsync(apiDisplayAreasById, action.payload)
    yield put({ type: GET_DISPLAYAREAS_DATA_SUCCESS, payload: data });
  } catch (e) {
    yield put({ type: GET_DISPLAYAREAS_DATA_ERROR, error: e.message });
  }
}


function* fetchDisplayAreasByIdAndTypeData(action) {
  try {
    const data = yield fetchAsync(apiDisplayAreasByIdAndType, action.id, action.displayAreaType)
    yield put({ type: GET_DISPLAYAREAS_DATA_SUCCESS, payload: data });
  } catch (e) {
    yield put({ type: GET_DISPLAYAREAS_DATA_ERROR, error: e.message });
  }
}

export const sagaDisplayAreas = [
  takeEvery(DISPLAYAREAS_LOADING, fetchDisplayAreasData),
  takeEvery(DISPLAYAREAS_BY_ID_LOADING, fetchDisplayAreasByIdData),
  takeEvery(DISPLAYAREAS_BY_ID_AND_TYPE_LOADING, fetchDisplayAreasByIdAndTypeData)
];
